import { Language } from './Language'

export const DEMO_JOB_IDS = ['hamlet', 'frankenstein', 'pandora', 'earnest', 'pygmalion', 'deposition'] as const

export type DemoJobId = (typeof DEMO_JOB_IDS)[number]

export const isDemoJobId = (id: string | null): id is DemoJobId => DEMO_JOB_IDS.includes(id as DemoJobId)

type DemoMockUrlsDescriptor = {
    defaultUrl: string
    translations: Partial<Record<Language, string>>
}
export const MOCK_URLS_BY_DEMO_JOB_ID: Record<DemoJobId, DemoMockUrlsDescriptor> = {
    hamlet: {
        defaultUrl: '/demo/hamlet-fr.json',
        translations: {
            [Language.German]: '/demo/hamlet-de.json',
            [Language.English]: '/demo/hamlet-en.json',
            [Language.Italian]: '/demo/hamlet-it.json',
            [Language.Spanish]: '/demo/hamlet-es.json',
        },
    },
    frankenstein: {
        defaultUrl: '/demo/frankenstein-en.json',
        translations: {
            [Language.German]: '/demo/frankenstein-de.json',
            [Language.French]: '/demo/frankenstein-fr.json',
            [Language.Italian]: '/demo/frankenstein-it.json',
            [Language.Spanish]: '/demo/frankenstein-es.json',
        },
    },
    pandora: {
        defaultUrl: '/demo/pandora-en.json',
        translations: {
            [Language.German]: '/demo/pandora-de.json',
            [Language.French]: '/demo/pandora-fr.json',
            [Language.Italian]: '/demo/pandora-it.json',
            [Language.Spanish]: '/demo/pandora-es.json',
        },
    },
    earnest: {
        defaultUrl: '/demo/earnest-en.json',
        translations: {
            [Language.German]: '/demo/earnest-de.json',
            [Language.French]: '/demo/earnest-fr.json',
            [Language.Italian]: '/demo/earnest-it.json',
            [Language.Spanish]: '/demo/earnest-es.json',
        },
    },
    pygmalion: {
        defaultUrl: '/demo/pygmalion-en.json',
        translations: {
            [Language.German]: '/demo/pygmalion-de.json',
            [Language.French]: '/demo/pygmalion-fr.json',
            [Language.Italian]: '/demo/pygmalion-it.json',
            [Language.Spanish]: '/demo/pygmalion-es.json',
        },
    },
    deposition: {
        defaultUrl: '/demo/deposition-en.json',
        translations: {},
    },
}
